import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { JourneyStep } from 'src/app/shared/models/journey.models';
import { JourneyStepCtaComponent } from 'src/app/shared/components/journey-step-cta/journey-step-cta.component';

/**
 * One tickable line of the onboarding journey, with the shortcut to the matching feature.
 *
 * The tick is a round medal rather than a checkbox, and a completed step is highlighted
 * instead of struck through: crossing a step out read as "cancelled" where the point is to
 * make it read as "earned".
 */
@Component({
  selector: 'app-journey-step-item',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    LucideAngularModule,
    JourneyStepCtaComponent,
  ],
  templateUrl: './journey-step-item.component.html',
})
export class JourneyStepItemComponent {
  step = input.required<JourneyStep>();
  /** True while the toggle request is in flight, to avoid double submits. */
  pending = input(false);

  toggled = output<string>();

  labelId = computed(() => `journey-step-label-${this.step().key}`);

  trackIcon = computed(() =>
    this.step().track === 'user' ? 'user' : 'building-2',
  );

  onToggle(): void {
    if (this.pending()) {
      return;
    }
    this.toggled.emit(this.step().key);
  }
}
